export interface ChannelValue {
  serie?: number;
  invoiceSequence?: number;
}

export interface DefaultSerie {
  serie?: number;
  invoiceSequence?: number;
}

export interface NfceSeriesChannelConfig {
  type_sale: number;
  serie: number | null;
  invoice_sequence: number | null;
}

export interface SaleChannel {
  id: number;
  name: string;
}

export const saleChannels: SaleChannel[] = [
  { id: 0, name: "Loja" },
  { id: 1, name: "Ifood" },
  { id: 2, name: "Uber Eats" },
  { id: 3, name: "Whatsapp" },
  { id: 4, name: "Telefone" },
  { id: 5, name: "App" },
  { id: 6, name: "Outros" },
  { id: 7, name: "Aiqfome" },
  { id: 9, name: "99 Foods" },
  { id: 10, name: "Açaí do Braga" },
];
